/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { createMachine } from 'xstate';

import PartnersApi from 'entities/partners/api';
import { CompanyAffiliationStep } from 'components/Flow/flows/nonprofitOnboardingCompanyAffiliation/components/CompanyAffiliationStep';

import { NonprofitOnboardingMachineEvents } from '../nonprofitOnboarding/machine';

export const nonprofitOnboardingCompanyAffiliationMachine = createMachine(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5QDsD2yAOAnVAzAlgC4DyyARqgIZYT7JQDCqAthpcgJ4CCuBANvkqF86AMQBVAAoARLgBUAogH0GxAHKKAGnIDaABgC6iUBlSwiI5MZAAPRAFYAzACYAdHueOALI4Ds9gBoQDkQARmcAXwigtEwcAhJyKho6RhY2Th5+QWF0VzoLSj585EK+UQBlcQAhAFkASV1Da1NzXKskWzCADlDXLy8ncMDgxEd7Pr1fXsdQ7oBOOfmANi8omPRsPCJSCmpaeiZWdm5efAEhSxKy6+EiyoBpesl9I07Wi3RrOwRwx3cvM4Vt1-EEQgh7D5XL4YeM9Kslqt1iBYlsErtkgc0sdMmcLu1boJirAAK5kZhEYT0UQQdBgEoAN1QAGt6aj4jskvtUkcMqdspc8gU7sSyRTCFSoAg6EyAMaC5CvV4tMyfDqgH6+Zx9exTXrOEbgg3-ea+Zb2ZbzRyLBarSLRFGbDmJPYpQ7pE5Zc45K7ComuUnkympURgLA4LCuDB8IS4VBYZiudnbF2Ynke3ECgl+ooBsXB+jS5ByhVK5rvVXtb4ObXQqZ6WYGsFhbyuZzOc2W62IwHI5Porlu7F8r3432lEWuXCUc4krBgSo1BpNN4mSuWasIDvzdy+QFzUGjX7zHdeUJeeFWm0rXt91AQODWfuc11Y3mevE+r4Vtobzo-ABacJXE7JsjwAi9oV8bxHHhPRegbexujvOIUwxbl3RxflvQVQkihVX9vw1MZ7FcGDD3BLxlmhDsLSvHt7Q2VCB1fdMsNHL9kDw4ocz4Ai1U3bp-nIw0SN8VwTy8Xx5m6ewkItWYULRF800wkdP1w3i8yDCVUn4qt-0QQZxJ8CjEANNxBlmWYFgYpTnXQod30zHDswnf1p1ned9L-Yit2WboyPGK0zN+M93HsZw9HmDwLKBaD7LQwc3wzbCxyFdzc1pZAwB8oiul+PR7HEzxumcfVRK3CY2wbUIbOvO0oiiIA */
    id: 'nonprofitOnboardingCompanyAffiliation',
    key: 'nonprofitOnboardingCompanyAffiliation',
    initial: 'initial',
    schema: {
      events: {} as NonprofitOnboardingMachineEvents,
      services: {} as {
        saveAffiliationService: {
          data: void;
        };
      },
    },
    states: {
      initial: {
        initial: 'initial',
        states: {
          initial: {
            on: {
              SUBMIT: 'submitting',
              SKIP: {
                target: 'done',
              },
            },
          },
          submitting: {
            invoke: {
              src: 'saveAffiliationService',
              onDone: {
                target: 'done',
              },
              onError: {
                target: 'failure',
              },
            },
          },
          failure: {
            on: {
              SUBMIT: 'submitting',
            },
          },
          done: {
            type: 'final',
            entry: ['handleFinal'],
          },
        },
        meta: {
          component: CompanyAffiliationStep,
        },
      },
    },
    tsTypes: {} as import('./machine.typegen').Typegen0,
  },
  {
    services: {
      saveAffiliationService: async (_context, event) => {
        if (event.type === 'SUBMIT') {
          await Promise.all(
            (event.companies || []).map((companyId) => PartnersApi.create(companyId).toPromise())
          ).catch((e) => {
            if (e.responseBody?.message !== 'Already added this organization as a partner') {
              throw e;
            }
          });
        }
      },
    },
  }
);
